var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-m",attrs:{"type":"button"},on:{"click":_vm.showBookingController}},[_vm._v("일정변경")])
}
var staticRenderFns = []

export { render, staticRenderFns }